module.exports = __webpack_public_path__ + "img/05_kudo_02.fbc34285.jpg";